import api from "../config/api";

import {
  ServiceReturn,
} from "../types/ServiceResponse";

import { Queue } from "../models/Queue";

export type GetAllQueuesPayload = undefined;

const moduleBaseUrl = "queue";

export const getAllQueues = async ( _payload?: GetAllQueuesPayload, token?: string ): Promise<ServiceReturn<Array<Queue>>> => {
  try {
    const {
      data
    } = await api.get(`/${ moduleBaseUrl }/all`, {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
